export default "__VITE_ASSET__BbwwggOj__"